module.exports = __webpack_public_path__ + "static/media/icon-company.525d88ef.svg";